import Cookies from "js-cookie";
import { RequestGatewayPlugin } from "../../../type";
import { isServer } from "../../../utils";

const tokenHeaderPlugin: RequestGatewayPlugin = {
  name: "tokenHeaderPlugin",
  type: "request",
  apply(config, options) {
    if (!isServer()) {
      const token = Cookies.get("token");
      if (config.headers) {
        if (token) {
          config.headers.set("token", token);
        } else {
          config.headers.delete("token");
        }
      }
    } else {
      config.timeout = 3 * 1000;
    }

    return config;
  },
};

export default tokenHeaderPlugin;
